module.exports = __webpack_public_path__ + "static/media/angle-down-blue.8c740361.svg";